/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {FC} from 'react'
import {VendorPage} from '../../component/vendor'

const VendorWrapper: FC = () => {
  return (
    <div>
      <VendorPage />
    </div>
  )
}

export {VendorWrapper}
